var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgPause = function SvgPause(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    ref: ref
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#fff",
    fillOpacity: 0.75,
    rx: 16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#161729",
    fillRule: "evenodd",
    d: "M11.714 10.857h1.715c.473 0 .857.384.857.858v8.571a.857.857 0 0 1-.857.857h-1.715a.857.857 0 0 1-.857-.857v-8.571c0-.474.384-.858.857-.858m6.858 0h1.714c.473 0 .857.384.857.858v8.571a.857.857 0 0 1-.857.857H18.57a.857.857 0 0 1-.857-.857v-8.571c0-.474.384-.858.858-.858",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPause);
export { ForwardRef as ReactComponent };